import { render } from "./Banner.vue?vue&type=template&id=fae41440"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"

import "./Banner.vue?vue&type=style&index=0&id=fae41440&lang=css"

import exportComponent from "/Users/iammaham/Documents/JS/estate_soluce/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__